import { ComponentIds, ProductUtils } from '@inter-ikea-core/core';
import { PlannerEcsMultiSystem } from './System';
import * as R from 'ramda';
import PlannerProductComponent from '../components/PlannerProductComponent';
import ShoppingBagComponent from '../components/ShoppingBagComponent';
/**
 * This system handles that the history event is sent when entities in scene changes, when something has been dragged in the scene or after loading snapshot (undo/redo)
 */
export class HistoryEventSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'HistoryEventSystem', [
            ComponentIds.IN_SCENE_COMPONENT_ID,
            ComponentIds.SOMETHING_IS_DRAGGED_COMPONENT_ID,
            ComponentIds.IS_LOADING_SNAPSHOT_COMPONENT_ID
        ]);
        this.currentProductsInScene = [];
        this.timer = null;
    }
    enable() {
        this.isEnabled = true;
        this.handleEntityUpdate(true);
    }
    onAdd(entity, newComponent) {
        if (!this.isEnabled)
            return;
        if (newComponent.typeId === ComponentIds.IN_SCENE_COMPONENT_ID &&
            (entity.hasComponent(PlannerProductComponent.id) ||
                entity.hasComponent(ShoppingBagComponent.id))) {
            this.handleEntityUpdate();
        }
    }
    onUpdate() { }
    onRemove(entity, oldComponent) {
        if (!this.isEnabled)
            return;
        if (((entity.hasComponent(PlannerProductComponent.id) ||
            entity.hasComponent(ShoppingBagComponent.id)) &&
            oldComponent.typeId === ComponentIds.IN_SCENE_COMPONENT_ID) ||
            oldComponent.typeId === ComponentIds.IS_LOADING_SNAPSHOT_COMPONENT_ID) {
            this.handleEntityUpdate();
        }
        else if (oldComponent.typeId === ComponentIds.SOMETHING_IS_DRAGGED_COMPONENT_ID) {
            this.handleDragCompleted();
        }
    }
    handleEntityUpdate(omitHistoryEvent = false) {
        if (this.timer)
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            const productsInScene = this.coreApi.entities
                .getByComponents([PlannerProductComponent.id, ShoppingBagComponent.id])
                .map(e => ProductUtils.productRefOrEmptyString(e));
            if (!R.equals(productsInScene, this.currentProductsInScene)) {
                if (!omitHistoryEvent)
                    this.coreApi.history.sendHistoryEvent();
                this.currentProductsInScene = productsInScene;
            }
        }, 100);
    }
    handleDragCompleted() {
        this.coreApi.history.sendHistoryEvent();
    }
}
//# sourceMappingURL=HistoryEventSystem.js.map